export default {
  lang: '',
};
